/* 會員相關接口 */

import request from '@/utils/http/request'



/* 會員列表 */
export async function fetchAll({ serialNo, phone, name, exp, page, pageSize }) {
    return await request.post('/member', {
        serialNo, phone, name, exp, page, pageSize
    }, {
        noAuth: false
    });
}

export async function pageExport({ serialNo, name, exp }) {
    return await request.post('/member', { serialNo, name, exp },
        {
            responseType: 'blob',
            noAuth: false
        }

    );
}
export async function store({ url }) {
    return await request.post('/member/store', {
        url
    }, {
        noAuth: false
    });
}

